<mat-toolbar class="main-header">
  @if (sidenav.mode === "over") {
    <button mat-icon-button (click)="toggleMenu()">
      @if (!sidenav.opened) {
        <mat-icon>menu</mat-icon>
      }
      @if (sidenav.opened) {
        <mat-icon>close</mat-icon>
      }
    </button>
  }
  <span>Campeón y Pichichi</span>
</mat-toolbar>

<div class="cp-wrapper">
  <!-- ── Hero ─────────────────────────────────────────────── -->
  <div class="cp-hero">
    <div class="cp-hero-bg"></div>
    <div class="cp-hero-content">
      <div class="cp-hero-icon">
        <mat-icon>emoji_events</mat-icon>
      </div>
      <h1 class="cp-hero-title">Pronósticos especiales</h1>
      <p class="cp-hero-sub">Elige tu campeón y tu pichichi del torneo</p>
    </div>
  </div>

  <!-- ── Body ─────────────────────────────────────────────── -->
  <div class="cp-body">
    @if (isLockedForViewer) {
      <div class="cp-locked-state">
        <span class="cp-locked-emoji">🏆🔒</span>
        <h3 class="cp-locked-title">Nadie espía antes del pitido</h3>
        <p class="cp-locked-sub">
          Los pronósticos de <strong>{{ user?.name }}</strong> están bajo siete
          llaves hasta que arranque la fase de grupos.<br />
          ¡Eso se llama fair play!
        </p>
      </div>
    }
    @if (!isLockedForViewer) {
      @if (!isAdmin && firstRoundIniTimestamp < currentTimestamp) {
        <div class="locked-banner">
          <mat-icon>lock</mat-icon>
          <span
            >El torneo ya ha comenzado. No puedes modificar tus
            pronósticos.</span
          >
        </div>
      }

      @if (user) {
        <!-- Champion card -->
        <div class="section-label">Campeón del mundo</div>
        <div class="cp-card">
          <div class="cp-card-preview">
            @if (user.champion?._id) {
              <img
                class="preview-flag"
                [src]="getSelectedChampionFlag()"
                alt=""
              />
            } @else {
              <div class="preview-placeholder">
                <mat-icon>outlined_flag</mat-icon>
              </div>
            }
          </div>
          <div class="cp-card-field">
            <mat-form-field appearance="outline" class="cp-field">
              <mat-label>Selecciona el equipo</mat-label>
              <mat-select
                [(ngModel)]="user.champion._id"
                [disabled]="
                  !isAdmin && firstRoundIniTimestamp < currentTimestamp
                "
              >
                @for (team of teams; track team) {
                  <mat-option class="teams-select" [value]="team._id">
                    <img [src]="team.flag" /> {{ team.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Pichichi card -->
        <div class="section-label">Pichichi</div>
        <div class="cp-card cp-card--pichichi">
          <div class="cp-card-preview">
            @if (pichichiTeamId) {
              <img class="preview-flag" [src]="getPichichiTeamFlag()" alt="" />
            } @else {
              <img
                class="preview-pichichi"
                src="assets/imgs/pichichi.png"
                alt="Pichichi"
              />
            }
          </div>
          <div class="cp-card-field cp-card-field--stack">
            <mat-form-field appearance="outline" class="cp-field">
              <mat-label>Equipo del jugador</mat-label>
              <mat-select
                [ngModel]="pichichiTeamId"
                (ngModelChange)="onPichichiTeamChange($event)"
                [disabled]="
                  !isAdmin && firstRoundIniTimestamp < currentTimestamp
                "
              >
                @for (team of teams; track team) {
                  <mat-option class="teams-select" [value]="team._id">
                    <img [src]="team.flag" /> {{ team.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            @if (pichichiPlayersLoading) {
              <div class="players-loading">
                <mat-icon class="spin">autorenew</mat-icon>
                <span>Cargando jugadores…</span>
              </div>
            }

            @if (!pichichiPlayersLoading && pichichiTeamId) {
              <mat-form-field appearance="outline" class="cp-field">
                <mat-label>Jugador</mat-label>
                <mat-select
                  [(ngModel)]="user.pichichi"
                  [disabled]="
                    !isAdmin && firstRoundIniTimestamp < currentTimestamp
                  "
                >
                  @for (player of pichichiPlayers; track player) {
                    <mat-option [value]="player._id">{{
                      player.name
                    }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
        </div>

        <!-- Save CTA -->
        @if (isAdmin || (firstRoundIniTimestamp > currentTimestamp && isMe)) {
          <button class="cta-btn" (click)="update()">
            <mat-icon>save</mat-icon>
            Guardar pronósticos
          </button>
        }
      }
    }
  </div>
</div>

<block-ui></block-ui>
